module.exports = __webpack_public_path__ + "img/course-item-a.28c123ea.png";